  /** Product Card Inner Sliders Global Init **/
  window.initProductCardSliders = function() {
    const sliders = document.querySelectorAll('.product-card-inner-slider');
    
    sliders.forEach(slider => {
      // If this specific element is already being handled or initialized, skip
      if (slider.isHandling || (slider.splideInstance && slider.classList.contains('is-initialized'))) return;
      
      try {
        slider.isHandling = true;

        // 1. CLEANUP: If there is an existing instance, destroy it first
        if (slider.splideInstance) {
          slider.splideInstance.destroy();
          slider.splideInstance = null;
        }

        // 2. DOM SCRUBBING
        slider.querySelectorAll('.splide__pagination, .splide__arrows').forEach(el => el.remove());

        // 3. INITIALIZE
        const splideInstance = new Splide(slider, {
          type: 'slide',
          perPage: 1,
          pagination: true,
          arrows: false,
          gap: '10px',
          rewind: true
        }).mount();
        
        slider.splideInstance = splideInstance;
        slider.classList.add('is-initialized');

        // 4. PREVENT REDIRECT: Stop click propagation on pagination dots
        slider.querySelectorAll('.splide__pagination').forEach(pagination => {
          pagination.addEventListener('click', (e) => {
            e.stopPropagation();
          });
        });

        // 5. EVENT: Listen for swatch changes
        if (!slider.hasGotoListener) {
          slider.addEventListener('goto-slide', (e) => {
            if (typeof e.detail.index !== 'undefined' && slider.splideInstance) {
              slider.splideInstance.go(parseInt(e.detail.index));
            }
          });
          slider.hasGotoListener = true;
        }
      } catch(e) {
        console.error('Splide Card Error:', e);
      } finally {
        slider.isHandling = false;
      }
    });
  };

  /** Global Product Card Interactivity (Swatches, etc.) **/
  document.addEventListener('click', function(e) {
    // 1. Variant Swatches handling
    const swatch = e.target.closest('.v-swatch-item');
    if (swatch) {
      const card = swatch.closest('.p-card-js');
      if (!card) return;

      // Update active state
      card.querySelectorAll('.v-swatch-item').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // Update UI elements
      const { variantId, variantTitle, variantPrice, variantCompare, variantImage, imageIndex } = swatch.dataset;
      
      if (variantId) {
        const idInput = card.querySelector('.variant-id-input');
        if (idInput) idInput.value = variantId;
      }
      
      if (variantPrice) {
        const priceDisp = card.querySelector('.p-current-price');
        if (priceDisp) priceDisp.innerText = variantPrice;
      }

      if (variantCompare) {
        const oldPriceDisp = card.querySelector('.p-old-price s');
        if (oldPriceDisp) oldPriceDisp.innerText = variantCompare;
      }

      if (variantTitle) {
        const titleDisp = card.querySelector('.p-variant-title-label');
        if (titleDisp) titleDisp.innerText = variantTitle;
      }

      if (variantImage) {
        const mainImg = card.querySelector('.main-p-image');
        if (mainImg) mainImg.src = variantImage;
      }

      // Sync Slider if exists
      if (typeof imageIndex !== 'undefined') {
        const sliderElement = card.querySelector('.product-card-inner-slider');
        if (sliderElement) {
          sliderElement.dispatchEvent(new CustomEvent('goto-slide', { 
            detail: { index: imageIndex },
            bubbles: true 
          }));
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', function() {
    window.initProductCardSliders();
    
    let debouncer;
    const observer = new MutationObserver((mutations) => {
       clearTimeout(debouncer);
       debouncer = setTimeout(() => {
         const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
         if (hasNewNodes) window.initProductCardSliders();
       }, 150);
    });
    observer.observe(document.body, { childList: true, subtree: true });
    
    document.addEventListener('shopify:section:load', () => {
       window.initProductCardSliders();
    });
  });

  /* --- Global Toast Notification System --- */
  window.showToast = function(message, type = 'success', duration = 3000) {
      let container = document.querySelector('.theme-toast-container');
      if (!container) {
          container = document.createElement('div');
          container.className = 'theme-toast-container';
          document.body.appendChild(container);
      }

      const toast = document.createElement('div');
      toast.className = `theme-toast toast-${type}`;
      
      let icon = '';
      if (type === 'success') {
          icon = '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';
      } else if (type === 'error') {
          icon = '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>';
      } else {
          icon = '<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>';
      }

      toast.innerHTML = `
          <div class="toast-icon">${icon}</div>
          <div class="toast-message">${message}</div>
      `;

      container.appendChild(toast);

      setTimeout(() => {
          toast.classList.add('fadeOut');
          toast.addEventListener('animationend', () => {
              toast.remove();
              if (container.childNodes.length === 0) {
                  container.remove();
              }
          }, { once: true });
      }, duration);
  };
